import { Permission, LimitUsage } from '@prezi/presentation-service-client';
export const PermissionValue = Permission.permission_value;
export const NotPossiblePermission = {
  permission_value: Permission.permission_value.NOT_POSSIBLE
};
export const mapUserPermissions = permissions => ({
  sharePrivacy: {
    public: {
      base: isAnyAllowed(permissions.share_public),
      copyrighted: permissions.share_public_copyrighted || NotPossiblePermission,
      reusable: permissions.share_public_reusable || NotPossiblePermission
    },
    hidden: {
      base: isAnyAllowed(permissions.share_hidden),
      copyrighted: permissions.share_hidden_copyrighted || NotPossiblePermission,
      reusable: permissions.share_hidden_reusable || NotPossiblePermission
    },
    private: {
      base: isAnyAllowed(permissions.share_private),
      copyrighted: permissions.share_private_copyrighted || NotPossiblePermission,
      reusable: permissions.share_private_reusable || NotPossiblePermission
    }
  },
  unlistedViewLink: {
    base: isAnyAllowed(permissions.share_unlisted_link_get, permissions.share_unlisted_link_generate, permissions.share_unlisted_link_delete),
    get: permissions.share_unlisted_link_get || NotPossiblePermission,
    generate: permissions.share_unlisted_link_generate || NotPossiblePermission,
    delete: permissions.share_unlisted_link_delete || NotPossiblePermission
  },
  unifiedPrivacy: {
    get: permissions.unified_privacy_get || NotPossiblePermission,
    set: {
      base: isAnyAllowed(permissions.unified_privacy_set_open_published, permissions.unified_privacy_set_open_published_reusable, permissions.unified_privacy_set_open_unpublished, permissions.unified_privacy_set_open_unpublished_reusable, permissions.unified_privacy_set_closed_unpublished, permissions.unified_privacy_set_closed_unpublished_reusable, permissions.unified_privacy_set_closed_published, NotPossiblePermission),
      open: {
        base: isAnyAllowed(permissions.unified_privacy_set_open_published, permissions.unified_privacy_set_open_published_reusable, permissions.unified_privacy_set_open_unpublished, permissions.unified_privacy_set_open_unpublished_reusable, NotPossiblePermission),
        published: {
          base: isAnyAllowed(permissions.unified_privacy_set_open_published, permissions.unified_privacy_set_open_published_reusable, NotPossiblePermission),
          copyrighted: permissions.unified_privacy_set_open_published || NotPossiblePermission,
          reusable: permissions.unified_privacy_set_open_published_reusable || NotPossiblePermission
        },
        unPublished: {
          base: isAnyAllowed(permissions.unified_privacy_set_open_unpublished, permissions.unified_privacy_set_open_unpublished_reusable),
          copyrighted: permissions.unified_privacy_set_open_unpublished || NotPossiblePermission,
          reusable: permissions.unified_privacy_set_open_unpublished_reusable || NotPossiblePermission
        }
      },
      closed: {
        base: isAnyAllowed(permissions.unified_privacy_set_closed_unpublished, permissions.unified_privacy_set_closed_unpublished_reusable, permissions.unified_privacy_set_closed_published),
        published: permissions.unified_privacy_set_closed_published || NotPossiblePermission,
        unPublished: {
          base: isAnyAllowed(permissions.unified_privacy_set_closed_unpublished, permissions.unified_privacy_set_closed_unpublished_reusable),
          copyrighted: permissions.unified_privacy_set_closed_unpublished || NotPossiblePermission,
          reusable: permissions.unified_privacy_set_closed_unpublished_reusable || NotPossiblePermission
        }
      }
    }
  },
  collaborator: {
    base: isAnyAllowed(permissions.collaborator_individual_add_viewer, permissions.collaborator_individual_add_commenter, permissions.collaborator_individual_add_editor, permissions.collaborator_individual_update_viewer, permissions.collaborator_individual_update_commenter, permissions.collaborator_individual_update_editor, permissions.collaborator_individual_remove_others, permissions.collaborator_organization_add_viewer, permissions.collaborator_organization_add_commenter, permissions.collaborator_organization_add_editor, permissions.collaborator_organization_remove),
    individual: {
      base: isAnyAllowed(permissions.collaborator_individual_add_viewer, permissions.collaborator_individual_add_commenter, permissions.collaborator_individual_add_editor),
      add: {
        base: isAnyAllowed(permissions.collaborator_individual_add_viewer, permissions.collaborator_individual_add_commenter, permissions.collaborator_individual_add_editor),
        viewer: permissions.collaborator_individual_add_viewer || NotPossiblePermission,
        commenter: permissions.collaborator_individual_add_commenter || NotPossiblePermission,
        editor: permissions.collaborator_individual_add_editor || NotPossiblePermission
      },
      update: {
        base: isAnyAllowed(permissions.collaborator_individual_update_viewer, permissions.collaborator_individual_update_commenter, permissions.collaborator_individual_update_editor),
        viewer: permissions.collaborator_individual_update_viewer || NotPossiblePermission,
        commenter: permissions.collaborator_individual_update_commenter || NotPossiblePermission,
        editor: permissions.collaborator_individual_update_editor || NotPossiblePermission
      },
      remove: permissions.collaborator_individual_remove_others || NotPossiblePermission
    },
    organization: {
      base: isAnyAllowed(permissions.collaborator_organization_add_viewer, permissions.collaborator_organization_add_commenter, permissions.collaborator_organization_add_editor, permissions.collaborator_organization_remove),
      add: {
        base: isAnyAllowed(permissions.collaborator_organization_add_viewer, permissions.collaborator_organization_add_commenter, permissions.collaborator_organization_add_editor),
        viewer: permissions.collaborator_organization_add_viewer || NotPossiblePermission,
        commenter: permissions.collaborator_organization_add_commenter || NotPossiblePermission,
        editor: permissions.collaborator_organization_add_editor || NotPossiblePermission
      },
      remove: permissions.collaborator_organization_remove || NotPossiblePermission
    }
  },
  viewLink: {
    base: isAnyAllowed(permissions.share_view_link_own_get, permissions.share_view_link_own_create, permissions.share_view_link_own_create_with_analytics, permissions.share_view_link_own_update, permissions.share_view_link_own_update_with_analytics, permissions.share_view_link_own_delete, permissions.share_view_link_all_get, permissions.share_view_link_all_update, permissions.share_view_link_all_delete),
    own: {
      base: isAnyAllowed(permissions.share_view_link_own_get, permissions.share_view_link_own_create, permissions.share_view_link_own_create_with_analytics, permissions.share_view_link_own_update, permissions.share_view_link_own_update_with_analytics, permissions.share_view_link_own_delete),
      get: permissions.share_view_link_own_get || NotPossiblePermission,
      create: permissions.share_view_link_own_create || NotPossiblePermission,
      createWithAnalytics: permissions.share_view_link_own_create_with_analytics || NotPossiblePermission,
      update: permissions.share_view_link_own_update || NotPossiblePermission,
      updateWithAnalytics: permissions.share_view_link_own_update_with_analytics || NotPossiblePermission,
      delete: permissions.share_view_link_own_delete || NotPossiblePermission
    },
    all: {
      base: isAnyAllowed(permissions.share_view_link_all_get, permissions.share_view_link_all_update, permissions.share_view_link_all_delete),
      get: permissions.share_view_link_all_get || NotPossiblePermission,
      update: permissions.share_view_link_all_update || NotPossiblePermission,
      delete: permissions.share_view_link_all_delete || NotPossiblePermission
    }
  }
});
export const isPermissionAllowed = permission => (permission === null || permission === void 0 ? void 0 : permission.permission_value) === PermissionValue.ALLOWED || (permission === null || permission === void 0 ? void 0 : permission.permission_value) === PermissionValue.ALLOWED_BUT_NO_EFFECT || (permission === null || permission === void 0 ? void 0 : permission.permission_value) === PermissionValue.ALLOWED_BUT_NOT_PREFERRED;
export const isPermissionPossible = permission => (permission === null || permission === void 0 ? void 0 : permission.permission_value) !== PermissionValue.NOT_POSSIBLE;
export const isPermissionNotAllowedWithCurrentLicense = permission => (permission === null || permission === void 0 ? void 0 : permission.permission_value) === PermissionValue.NOT_ALLOWED_WITH_CURRENT_FEATURES;
export const isPermissionNotAllowedBecauseLimitReached = permission => (permission === null || permission === void 0 ? void 0 : permission.permission_value) === PermissionValue.NOT_ALLOWED_LIMIT_REACHED;
export const isPermissionNotAllowedInOrg = permission => (permission === null || permission === void 0 ? void 0 : permission.permission_value) === PermissionValue.NOT_ALLOWED_IN_ORG;
export const isAnyAllowed = (...permissions) => permissions.reduce((curr, prev) => curr || isPermissionAllowed(prev), false);
const VIEW_LINK_LIMIT = 1;
export const fixViewLinkCreatePermissionWithLimit = (linkCount, createPermission) => {
  if (createPermission.limits && linkCount >= VIEW_LINK_LIMIT) {
    return {
      ...createPermission,
      permission_value: PermissionValue.NOT_ALLOWED_LIMIT_REACHED,
      limits: [{
        code: LimitUsage.code.VIEW_LINK_LIMIT,
        limit_value: VIEW_LINK_LIMIT,
        current_value: linkCount,
        reached: true
      }]
    };
  } else {
    return createPermission;
  }
};
export const fixViewLinkOwnPermissionWithLimit = (linkCount, viewLinkPermission) => {
  if (viewLinkPermission) {
    return {
      ...viewLinkPermission,
      create: fixViewLinkCreatePermissionWithLimit(linkCount, viewLinkPermission.create),
      createWithAnalytics: fixViewLinkCreatePermissionWithLimit(linkCount, viewLinkPermission.createWithAnalytics)
    };
  } else {
    return undefined;
  }
};